import Vue from 'vue';
import {
    TIPO_DATI_CENSIMENTI,
    POTATURA_DA_POTARE,
    POTATURA_DA_POTARE_PRECEDENTEMENTE_CAPITOZZATO,
    INTERVENTO_FITOSANITARIO_DANNI_DA_INSETTI,
    INTERVENTO_FITOSANITARIO_MICOSI,
    INTERVENTO_ESEGUITO_POTATURA,
    INTERVENTO_ESEGUITO_FITOSANITARIO_DANNI_DA_INSETTI,
    INTERVENTO_ESEGUITO_FITOSANITARIO_MICOSI
} from '@/costanti';

const filtraPerUrgenza = (state: any, rilevamento: any) => {
    if (state.filtroUrgenza > 0) {
        const urgenzeBuone = [state.filtroUrgenza, state.filtroUrgenza + 1];
        return urgenzeBuone.includes(rilevamento.urgenza_intervento_id);
    } else {
        return true;
    }
};

// if filter == -1, dont send to backend
function postValueForFilter(value: number) {
    if (value < 0) {
        return undefined;
    } else {
        return value;
    }
}

export default {
    namespaced: true,
    state: {
        rilevamenti: [],
        statoRilevamenti: null,
        tipoDatiMostrati: TIPO_DATI_CENSIMENTI,
        filtroUrgenza: -1,
        rilevamentoMostrato: null
    },
    getters: {
        rilevamentiGeojson: (state: any) => ({
            type: 'FeatureCollection',
            features: state.rilevamenti.map((rilevamento: any) => ({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [rilevamento.longitudine, rilevamento.latitudine]
                },
                properties: {
                    id: rilevamento.id,
                    tipoPianta: rilevamento.tipo_pianta
                }
            }))
        }),
        pianteDaPotareGeojson: (state: any) => ({
            type: 'FeatureCollection',
            features: state.rilevamenti
                .filter((rilevamento: any) => [POTATURA_DA_POTARE, POTATURA_DA_POTARE_PRECEDENTEMENTE_CAPITOZZATO].includes(rilevamento.potatura_id))
                .filter((rilevamento: any) => filtraPerUrgenza(state, rilevamento))
                .map((rilevamento: any) => ({
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [rilevamento.longitudine, rilevamento.latitudine]
                    },
                    properties: {
                        id: rilevamento.id,
                        wasCut: rilevamento.interventi_eseguiti
                            .findIndex(item => item.tipo_intervento_id === INTERVENTO_ESEGUITO_POTATURA) > -1
                    }
                }))
        }),
        pianteConDanniDaInsettoGeojson: (state: any) => ({
            type: 'FeatureCollection', features: state.rilevamenti
                .filter((rilevamento: any) => rilevamento.interventi_fitosanitari.includes(INTERVENTO_FITOSANITARIO_DANNI_DA_INSETTI))
                .filter((rilevamento: any) => filtraPerUrgenza(state, rilevamento))
                .map((rilevamento: any) => ({
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [rilevamento.longitudine, rilevamento.latitudine]
                    },
                    properties: {
                        id: rilevamento.id,
                        wasFixed: rilevamento.interventi_eseguiti
                            .findIndex(item => item.tipo_intervento_id === INTERVENTO_ESEGUITO_FITOSANITARIO_DANNI_DA_INSETTI) > -1
                    }
                }))
        }),
        pianteConMicosiGeojson: (state: any) => ({
            type: 'FeatureCollection',
            features: state.rilevamenti
                .filter((rilevamento: any) => rilevamento.interventi_fitosanitari.includes(INTERVENTO_FITOSANITARIO_MICOSI))
                .filter((rilevamento: any) => filtraPerUrgenza(state, rilevamento))
                .map((rilevamento: any) => ({
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [rilevamento.longitudine, rilevamento.latitudine]
                    },
                    properties: {
                        id: rilevamento.id,
                        wasFixed: rilevamento.interventi_eseguiti
                            .findIndex(item => item.tipo_intervento_id === INTERVENTO_ESEGUITO_FITOSANITARIO_MICOSI) > -1
                    }
                }))
        })
    },
    mutations: {
        CARICA_RILEVAMENTI: (state: any, payload: any) => {
            state.rilevamenti = payload;
        },
        SET_STATO_RILEVAMENTI: (state: any, payload: any) => {
            state.statoRilevamenti = payload;
        },
        SET_TIPO_DATI_MOSTRATI: (state: any, payload: any) => {
            state.tipoDatiMostrati = payload;
        },
        SET_FITRO_URGENZA: (state: any, payload: number) => {
            state.filtroUrgenza = payload;
        },
        // == Rilevamento mostrato ==
        SET_RILEVAMENTO_MOSTRATO: (state: any, rilevamento: any) => {
            state.rilevamentoMostrato = rilevamento;
        }
    },
    actions: {
        async caricaRilevamenti({commit, rootState}: any) {
            // se stiamo filtrando per urgenza
            // se è 1, significa [1,2] immediato o urgente
            // se è 3, significa [3,4] entro tre anni o opzionale
            const urgenzaInterventoMirco =
                rootState.mapplantsFiltriCensimento.urgenzaIntervento > 0 ?
                    [rootState.mapplantsFiltriCensimento.urgenzaIntervento, rootState.mapplantsFiltriCensimento.urgenzaIntervento + 1] : [];

            try {
                const response = await Vue.axios
                    .get('/api_mapplants/rilevamenti_light.json', {
                        params: {
                            id: rootState.mapplantsFiltriCensimento.idRilevamento ? rootState.mapplantsFiltriCensimento.idRilevamento : undefined,
                            giudizio_radici_colletto_id: postValueForFilter(rootState.mapplantsFiltriCensimento.giudizioRadiciColletto),
                            giudizio_fusto_branche_id: postValueForFilter(rootState.mapplantsFiltriCensimento.giudizioFustoBranche),
                            giudizio_rami_chioma_id: postValueForFilter(rootState.mapplantsFiltriCensimento.giudizioRamiChioma),
                            contesto_id: postValueForFilter(rootState.mapplantsFiltriCensimento.contesto),
                            urgenza_intervento_id__in: urgenzaInterventoMirco.join(','),
                            monitoraggio_id: postValueForFilter(rootState.mapplantsFiltriCensimento.monitoraggio),
                            id_targhetta: postValueForFilter(rootState.mapplantsFiltriCensimento.idTag)
                        }
                    });
                const rilevamenti = response.data;
                // carica i rilevamenti geojson
                commit('CARICA_RILEVAMENTI', rilevamenti);
            } catch (err) {
                console.error(err);
            }
        },
        async caricaStatoRilevamenti({commit}: any) {
            try {
                const response = await Vue.axios.get('/mapplants/stato_rilevamenti.json');
                commit('SET_STATO_RILEVAMENTI', response.data);
            } catch (err) {
                console.error(err);
            }
        },
        async cambiaRilevamentoMostrato({commit, rootState}: any, id: number) {
            // toglie il precedente
            commit('SET_RILEVAMENTO_MOSTRATO', null);
            // troviamo il rilevamento
            try {
                const response = await Vue.axios.get(`/api_mapplants/rilevamenti.json?id=${id}`);
                const rilevamento = response.data[0];
                commit('SET_RILEVAMENTO_MOSTRATO', rilevamento);
            } catch (err) {
                console.error(err);
            }
        }
    }
};
